import React from 'react';
import { Button, Message } from 'barnyard/components';
import { LEARN_VETCOVE_URL } from '../constants';

const classNamePrefix = 'Signup--LearnRedirectNotice';

const LearnRedirectNotice = () => (
  <Message
    color='warning'
    border={true}
    className={classNamePrefix}
    message={(
      <div className={`${classNamePrefix}__content`}>
        <p>
          This page is for verified veterinary practices only. If you&apos;re a student looking
          for Learn with Vetcove, you can register at{' '}
          <a href={LEARN_VETCOVE_URL} target='_blank' rel='noopener noreferrer'>
            learn.vetcove.com
          </a>.
        </p>
        <Button
          node='a'
          href={LEARN_VETCOVE_URL}
          target='_blank'
          rel='noopener noreferrer'
          color='primary'
        >
          Register for Learn with Vetcove
        </Button>
      </div>
    )}
  />
);

export default LearnRedirectNotice;
